export type CustomerGroupsMeta = { id: number; enabled: boolean; name: string; customers: { id: number; name }[] };

/** The "Number of customers" a group shows and exports; `customerGroupPage` filters on the same count. */
export const customerCount = (group: CustomerGroupsMeta) => group.customers.length;
